export default __webpack_public_path__ + "static/media/pro@3x.b54e48ed.png";